// Frontend Sentry initialisation. Loaded before <App /> mounts.
//
// Env vars (baked at build time by CRA):
//   REACT_APP_SENTRY_DSN           (required to activate)
//   REACT_APP_SENTRY_ENV           default "development"
//   REACT_APP_SENTRY_RELEASE       default "tradinggodai@dev"
//   REACT_APP_SENTRY_TRACES_RATE   default "0.10"
//   REACT_APP_SENTRY_REPLAY_RATE   default "0.0"
//
// No-op when DSN is empty.
import * as Sentry from "@sentry/react";

let _enabled = false;

export function initSentry() {
  const dsn = process.env.REACT_APP_SENTRY_DSN || "";
  if (!dsn) {
    // eslint-disable-next-line no-console
    console.info("[sentry] disabled (REACT_APP_SENTRY_DSN unset)");
    return false;
  }
  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENV || "development",
    release: process.env.REACT_APP_SENTRY_RELEASE || "tradinggodai@dev",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: parseFloat(process.env.REACT_APP_SENTRY_TRACES_RATE || "0.10"),
    replaysSessionSampleRate: parseFloat(process.env.REACT_APP_SENTRY_REPLAY_RATE || "0.0"),
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event) {
      // Strip obvious PII / secrets before sending
      if (event.request?.headers) {
        for (const k of Object.keys(event.request.headers)) {
          if (/authorization|cookie|api[-_]?key|token/i.test(k)) {
            event.request.headers[k] = "***redacted***";
          }
        }
      }
      return event;
    },
  });
  _enabled = true;
  // eslint-disable-next-line no-console
  console.info("[sentry] enabled", {
    env: process.env.REACT_APP_SENTRY_ENV,
    release: process.env.REACT_APP_SENTRY_RELEASE,
  });
  return true;
}

export function isSentryEnabled() {
  return _enabled;
}

export const SentryErrorBoundary = Sentry.ErrorBoundary;
export const captureException = Sentry.captureException;
export const setUser = Sentry.setUser;
